<template>
  <div>
	<!-- <div class="loader" v-if="isLoading">
      <CSpinner variant="grow" />
    </div> -->
    <CRow>
      <CCol sm="12">
        <CCard>
          <CCardHeader>
            <strong>Edit Feedback Questions</strong>
          </CCardHeader>
          <CCardBody>
			<CForm class="formData">
            <CRow>
				<CCol sm="12">                
					<label class="m-0 col-fonts-black">Select Role</label>
				</CCol>
				<CCol sm="12" class="mb-3">				
					<select class="v-select" id="rollselect">
						<option  v-for="role in modulesArr" :value="role.Module_Id">{{role.ModuleName}}</option> 
					</select>              	
              </CCol>
            </CRow>
			<CRow>
				 <CCol sm="12">
					<CInput
					  label="Purpose" id="purpose"
					  placeholder="Purpose" name="purpose" :value="purpose"
					/>
				  </CCol>			  
			</CRow>
			
			<div id="newQustions">
					
			</div>
			
            <CRow>
				<CCol sm="6">
				</CCol>
				<CCol sm="6">
				<button aria-pressed="true" type="button" autocomplete="off" class="btn btn-outline-light btn-block active fw-300 col-white fs-18" @click="addMore()">Add Question</button>
				</CCol>
			</CRow>
            <CRow>
			<CCol sm="6" class="m-10">
				<button aria-pressed="true" type="button" autocomplete="off" class="btn btn-outline-light btn-block active fw-500 col-white fs-18" @click="back()">Cancel</button>
              </CCol>
              <CCol sm="6">
                <button aria-pressed="true" type="button" autocomplete="off" class="btn btn-outline-info btn-block active fw-500 col-white fs-18" @click="submit()">Save</button>
			</CCol>
			 
            </CRow>
			</CForm>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
//import { ModelSelect } from 'vue-search-select';
import axios from "axios";
export default {
  name: 'Edit_questions',
  data () {
    return {		
		status:['Enable','Disable'],
		question_types:['Text','Radio','Dropdown','Rating','Checkbox'],
		modulesArr: [],
		Module_Id:0,
		question_inx:0,	
		feedback_form_id:0,
		purpose:'',
		questionsArr:[],
		isLoading: false		
    }
  },
  mounted () {
	this.isLoading = true;
	var token=localStorage.getItem("auth");
	var Session_User_Id=JSON.parse(localStorage.getItem("User_Id"));	
	var requestInfo = {	
		Token:token,
		Session_User_Id:Session_User_Id,
	};
	var self = this;
	var data = JSON.stringify(requestInfo);							
			var config = {
			  method: 'post',
			  url: apiURL+'ManageModule/GetModuleList',
			  headers: { 
				'Content-Type': 'application/json'
			  },
			  data : data
		};
	axios(config)
		.then((result) => {		
			this.isLoading = false;
			if(result.data.status_code==200){
				var obj=result.data.response;								
				self.modulesArr=obj;					
				
				//Edit data get
				var id=JSON.parse(localStorage.getItem("feedback_form_id"));
				var requestInfo = {	
					Token:token,
					Session_User_Id:Session_User_Id,					
				};
				console.log(requestInfo);
				var self1 = self;
				var data = JSON.stringify(requestInfo);							
						var config = {
						  method: 'get',
						  url: feedbackApiURL+'getAllFeedBacks/'+id,
						  headers: { 
							'Content-Type': 'application/json'
						  },
						  data : data
					};
				this.isLoading = true;
				axios(config)
					.then((result) => {	
						this.isLoading = false;						
						if(result.data.status_code==200){
							var obj=result.data.feedBacks[0];	
							
							self1.feedback_form_id=obj.feedback_form_id;
							self1.Module_Id=obj.Module_Id;							
							self1.purpose=obj.purpose;							
							self1.questionsArr=obj.questions;
														
							var qrow=obj.questions;	
							//console.log(qrow);
							var divhtml='';
							for(var a=0;a < qrow.length;a++){							
								self1.question_inx=self1.question_inx+1;
								var EnableStatus='';
								var DisableStatus='';
								if(qrow[a].status==1){
									EnableStatus='selected';
								}else{
									DisableStatus='selected';
								}
								var Text='';
								var Radio='';
								var Dropdown='';
								var Rating='';
								var Checkbox='';
								if(qrow[a].question_type=='Text'){
									Text='selected';
								}else if(qrow[a].question_type=='Radio'){
									Radio='selected';
								}else if(qrow[a].question_type=='Dropdown'){
									Dropdown='selected';
								}else if(qrow[a].question_type=='Rating'){
									Rating='selected';
								}else if(qrow[a].question_type=='Checkbox'){
									Checkbox='selected';
								}
								
								var newQ='<hr/><div class="row"><div class="col-sm-12"><label class="m-0 col-fonts-black">Question</label></div><div class="mb-3 col-sm-12"><textarea id="question_'+self1.question_inx+'" rows="2" class="question_class form-control" placeholder="Enter question">'+qrow[a].question+'</textarea></div></div>'
								+'<div class="row"><div class="col-sm-12"><label class="m-0 col-fonts-black">Question Type</label></div><div class="mb-3 col-sm-12"><select id="type_'+self1.question_inx+'" class="v-select form-control type_class"><option '+Text+'>Text</option><option '+Radio+'>Radio</option><option '+Dropdown+'>Dropdown</option><option '+Rating+'>Rating</option><option '+Checkbox+'>Checkbox</option></select></div></div>'
								+'<div class="row"><div class="col-sm-12"><div role="group" class="form-group"><label for="answer_type_0"> Value </label><input id="answer_type_'+self1.question_inx+'" type="text" placeholder="Answer Comma Separated" name="answer_value" class="form-control answer_value_class" value="'+qrow[a].values+'"></div></div></div>'
								+'<div class="row"><div class="col-sm-12"><label class="m-0 col-fonts-black">Enable/Disable</label></div><div class="mb-3 col-sm-12"><select id="status_'+self1.question_inx+'" class="v-select form-control status_class"><option '+EnableStatus+'>Enable</option><option '+DisableStatus+'>Disable</option></select></div></div><input type="hidden" value="'+qrow[a].questions_id+'" id="questions_'+self1.question_inx+'">';								
								divhtml+=newQ;
							}
							setTimeout(function(){ 
							$('#rollselect').val(obj.module_id);
							$('#newQustions').append(divhtml); 							
							}, 1000);
													
							
						}else{				
							this.$swal.fire({
							  icon: 'error',
							  title: 'Oops...',
							  text: result.data.message		 
							})
						}
				})
				.catch((error) => {					
					this.$swal.fire({
						icon: 'error',
						title: 'Oops...',
						text: 'Something went wrong!'		 
					})
				});
			}else{				
				this.$swal.fire({
				  icon: 'error',
				  title: 'Oops...',
				  text: result.data.message		 
				})
			}
	})
	.catch((error) => {
		this.isLoading = false;
		//var errorObject=JSON.stringify(error.response.data.errors);			
		//console.log(errorObject);		   
		this.$swal.fire({
			icon: 'error',
			title: 'Oops...',
			text: 'Something went wrong!'		 
		})
    });
  },
  computed: {
        
  },
  methods: {
    validator (val) {
      return val ? val.length >= 4 : false
    },
	back(){
		console.log('call');
		this.$router.push({path:'Manage_assign_module'})
	},
	addMore(){
		console.log('callll');
		//var newel = $('#newQustions').clone();				
		//$('#cloneDiv').clone().appendTo("#newQustions");
		
		this.question_inx=this.question_inx+1;
		var newQ='<hr/><div class="row"><div class="col-sm-12"><label class="m-0 col-fonts-black">Question</label></div><div class="mb-3 col-sm-12"><textarea id="question_'+this.question_inx+'" rows="2" class="question_class form-control" placeholder="Enter question"></textarea></div></div>'
		+'<div class="row"><div class="col-sm-12"><label class="m-0 col-fonts-black">Question Type</label></div><div class="mb-3 col-sm-12"><select id="type_'+this.question_inx+'" class="v-select form-control type_class"><option>Text</option><option>Radio</option><option>Dropdown</option><option>Rating</option><option>Checkbox</option></select></div></div>'
		+'<div class="row"><div class="col-sm-12"><div role="group" class="form-group"><label for="answer_type_0"> Value </label><input id="answer_type_'+this.question_inx+'" type="text" placeholder="Answer Comma Separated" name="answer_value" class="form-control answer_value_class"></div></div></div>'
		+'<div class="row"><div class="col-sm-12"><label class="m-0 col-fonts-black">Enable/Disable</label></div><div class="mb-3 col-sm-12"><select id="status_'+this.question_inx+'" class="v-select form-control status_class"><option>Enable</option><option>Disable</option></select></div></div>';
		
		$('#newQustions').append(newQ);		
	},
	roleSel(value) {		
	},
	submit(){
		this.isLoading = true;
		var Item_Id=localStorage.getItem("feedback_form_id");		
		var Session_User_Id=JSON.parse(localStorage.getItem("User_Id"));
		var token=localStorage.getItem("auth");
				
		var Module_Id=$('#rollselect').val();
		var purpose=$('#purpose').val();
		var questionArr= [];
		$('.question_class').each(function(){
			var question_val=$(this).val();
			if(question_val!=''){
			var qattr=$(this).attr('id');			
			var sids=qattr.split('_');
			var inxID=sids[1];
			
			var question_type=$('#type_'+inxID).val();
			var getstatus=$('#status_'+inxID).val();
			
			var status_flag=0;
			if(getstatus=='Enable'){
				status_flag=1;
			}
			var answer_type=$('#answer_type_'+inxID).val();
			
			var questions_id=$('#questions_'+inxID).val();
			
			var qreq={'question_type':question_type,'question':question_val,'values':answer_type,'questions_id':questions_id,'status':status_flag}
			
			questionArr.push(qreq);	
			}			
		});
		
		var requestInfo = {
		  Token:token,
		  Session_User_Id:Session_User_Id,
		  feedback_form_id:this.feedback_form_id,
		  Module_Id:parseFloat(Module_Id),
		  purpose:purpose,
		  loQuestions:questionArr
		};
		var self =this;		

		var data = JSON.stringify(requestInfo);	
		console.log(data);
		//return false;			
			var config = {
			  method: 'post',			  			  
			  url: feedbackApiURL+'updateFeedBack',
			  headers: { 
				'Content-Type': 'application/json'
			  },
			  data : data
		  };
      
		axios(config)
		.then((result) => {
			console.log(result);
			this.isLoading = false;	
			if(result.data.status_code==200){				
				self.$swal.fire(
					'Saved',
					result.data.message,
					'success'
				);
				$('.formData')[0].reset();
			}else{									
				self.$swal.fire({
				  icon: 'error',
				  title: 'Oops...',
				  text: result.data.message		 
				})
			}
		  
		})
		.catch((error) => {	
			this.isLoading = false;				  
			this.$swal.fire({
			  icon: 'error',
			  title: 'Oops...',
			  text: 'Something went wrong!'		 
			})
		});
	}
  }
}
</script>
